import { render, staticRenderFns } from "./jianPeiSetting.vue?vue&type=template&id=26c9541a&scoped=true"
import script from "./jianPeiSetting.vue?vue&type=script&lang=js"
export * from "./jianPeiSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c9541a",
  null
  
)

export default component.exports